// Angular
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { IdClassifierResult } from '@app/dto/IdClassifierResult';
import SessionStorage from '@app/helpers/SessionStorage';
import { GenericMessage } from '@app/interfaces/generic-message';
import { BottomBarService } from '@app/services/bottom-bar.service';
import { HwComputerVisionService } from '@app/services/hw-computer-vision.service';
import { ImageCaptureService } from '@app/services/image-capture-service';
import { CaptureMode, MessageType } from '@app/types/Types';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
// 3rdparty
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
// Hostware
import DateHelper from '@app/helpers/DateHelper';
import { VizaData } from '@app/interfaces/VizaData';
import { SpinnerService } from '@app/services/spinner.service';
import { DetectionLimitErrorDialogComponent } from '@app/dialogs/detection-limit-error-dialog/detection-limit-error.dialog.component'
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import LocalStorage from '@app/helpers/LocalStorage';
import { DocumentReadModes } from '@app/enums/DocumentReadModes';
import PhotoHelper from '@app/helpers/PhotoHelper';
import { VizaDataService } from '@app/services/viza-data.service';
import { HeaderService } from '@app/services/header.service';
import HwUtils from '@app/helpers/HwUtils';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
import { Country } from '@app/interfaces/Country';
import { LoadCsvService } from '@app/services/loadCsv.service';
@AutoUnsubscribe()
@Component({
  selector: 'photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.scss']
})
export class PhotoComponent implements OnInit, OnDestroy {

  idClassifier$: Subscription;
  faceMatch$: Subscription;
  hasImage: boolean = false;
  hasSelfie: boolean = false;
  needSelfie: boolean
  faceMatch: boolean = false;
  message: string = '';
  countries: Country[] = [];

  captureMode: CaptureMode = 'DOCUMENT';   // available values: "d1"-document side1, "d2"-document side2   "s"-selfie
  imageWidth: number = 1024;
  spinnerVisibility: boolean;
  _width = window.innerWidth;
  _height = window.innerHeight;
  landscape: boolean;
  isNewPhoto: boolean = environment.isNewPhoto;

  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  initialised : boolean = false

  constructor(
    private captureService: ImageCaptureService,
    private hwCwService: HwComputerVisionService,
    private bottomBarService: BottomBarService,
    private translate: TranslateService,
    private errorDialog: MatDialog,
    private router: Router,
    private spinnerService: SpinnerService,
    private breakPointObserver: BreakpointObserver,
    private dialog: MatDialog,
    public sessionStorageService: SessionstorageService,
    private chatService: ChatService,
    private imageCaptureService: ImageCaptureService,
    private vizaDataService: VizaDataService
  ) { }

  ngOnInit() {
    this.needSelfie = PhotoHelper.NeedSelfie();
    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;
     if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })

    this.breakPointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe((state: BreakpointState) => {
      state.breakpoints[Breakpoints.HandsetLandscape] ? this.landscape = true : this.landscape = false;
    })

    if (SessionStorage.FaceImageFromCard !== '') this.hasImage = true;
    if (SessionStorage.Selfie !== '') this.hasSelfie = true;

    this.bottomBarService.setBottomBarVisibility(false)
    SessionStorage.RetryCountSelfie = 0;
    SessionStorage.RetryCountImage = 0
    SessionStorage.RetryCountMrz = 0;


    if (this.needSelfie) {
      if (SessionStorage.MrzData && this.hasImage) {
        this.captureMode = 'SELFIE'
        this.imageCaptureService.startCapture.emit('SELFIE');
        this.message = this.translate.instant('photo.make_a_selfie')
        this.imageCaptureService.setInstructionText.emit(this.message)

      } else {
        if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
          this.message = this.translate.instant('photo.read_faceimage_side');
          this.imageCaptureService.startCapture.emit('DOCUMENT');
          this.imageCaptureService.setInstructionText.emit(this.message)
        }
        if (this.hasImage && !SessionStorage.MrzData) {
          this.imageCaptureService.startCapture.emit('DOCUMENT');
          this.message = this.translate.instant('photo.read_mrz_side');
          this.imageCaptureService.setInstructionText.emit(this.message)
        }
      }
    } else {
      if (!SessionStorage.MrzData) {
        this.imageCaptureService.startCapture.emit('DOCUMENT');
        this.message = this.translate.instant('photo.read_mrz_side');
        this.imageCaptureService.setInstructionText.emit(this.message)
      }
    }

     this.initialised = true
    this.captureService.imageApproved.subscribe(base64Img => {

      this.message = "";
      if (this.captureMode !== 'SELFIE') {
        this.spinnerService.setSpinnerVisibility(true);
        this.spinnerVisibility = true;
        this.idClassifier$ = this.hwCwService.scanDocument(base64Img).subscribe(
          {
            next: (result) => {
              this.spinnerVisibility = false;
              this.spinnerService.setSpinnerVisibility(false);
              const res = result as IdClassifierResult;
              // van kép, és mégnem volt előzőleg tárolva
              if (res.HasFace && SessionStorage.FaceImageFromCard == '') {
                SessionStorage.FaceImageFromCard = res.FaceImage;
                this.hasImage = true;
              }

              if (!SessionStorage.MrzData && res.MrzFields["Surname"]) {
                SessionStorage.MrzData = res.MrzFields;
              }

              if (!SessionStorage.MrzData && !this.hasImage) {
                SessionStorage.RetryCountMrz += 1
                SessionStorage.RetryCountImage += 1
              }

              if (!SessionStorage.MrzData && this.hasImage) {
                SessionStorage.RetryCountMrz += 1
              }
              if (SessionStorage.MrzData && !this.hasImage) {
                SessionStorage.RetryCountImage += 1
              }

              if (SessionStorage.RetryCountImage == 3 || SessionStorage.RetryCountMrz == 3) {
                this.showDetectionLimitError();
              }
              if (!SessionStorage.MrzData && !this.hasImage) {
                this.showDialog(this.translate.instant('photo.document_process_error'), 'ERROR')
              }
              if (this.needSelfie) {
                if (SessionStorage.MrzData && this.hasImage) {
                  this.captureMode = 'SELFIE'
                  this.message = this.translate.instant('photo.make_a_selfie');
                  this.imageCaptureService.setInstructionText.emit(this.message)
                  this.imageCaptureService.startCapture.emit('SELFIE')
                } else {
                  if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
                    this.message = this.translate.instant('photo.read_faceimage_side');
                    this.imageCaptureService.startCapture.emit('DOCUMENT')
                    this.imageCaptureService.setInstructionText.emit(this.message)
                  }
                  if (this.hasImage && !SessionStorage.MrzData) {
                    this.message = this.translate.instant('photo.read_mrz_side');
                    this.imageCaptureService.setInstructionText.emit(this.message)
                  }
                }
              } else {
                if (!SessionStorage.MrzData) {
                  this.message = this.translate.instant('photo.read_mrz_side');
                  this.imageCaptureService.setInstructionText.emit(this.message)
                } else {
                  SessionStorage.FaceImageFromCard = '';
                  SessionStorage.Selfie = '';
                  this.imageCaptureService.releaseCamera.emit()
                  this.router.navigateByUrl('/idverificationok')
                }
              }
              this.captureService.processFinished.emit();
            },
            error: (err: HttpErrorResponse) => {
              this.spinnerService.setSpinnerVisibility(false);
              this.spinnerVisibility = false;
              this.showDialog(this.translate.instant('photo.document_process_error'), 'ERROR')
              this.showMessage();
               this.captureService.processFinished.emit();
            }
          }
        )
      } else {
        SessionStorage.Selfie = base64Img;
        this.hasSelfie = true;
        if (this.needSelfie) {
          if (this.hasImage && this.hasSelfie && SessionStorage.MrzData) {
            this.spinnerService.setSpinnerVisibility(true);
            this.spinnerVisibility = true;
            this.faceMatch$ = this.hwCwService.compareFaces(SessionStorage.FaceImageFromCard, SessionStorage.Selfie).subscribe({
              next: (result) => {
                this.spinnerService.setSpinnerVisibility(false);
                this.spinnerVisibility = false;

                if (result["Match"] === false) {
                  SessionStorage.RetryCountSelfie += 1;
                  if (SessionStorage.RetryCountSelfie == 3) {
                    this.showDetectionLimitError();
                  } else {
                    this.showDialog(this.translate.instant('photo.face_compare_error'),'ERROR');
                  }
                  this.hasSelfie = false;
                  this.showMessage();
                }
                else {
                  this.imageCaptureService.releaseCamera.emit();
                  this.router.navigateByUrl('/idverificationok')
                }
                 this.captureService.processFinished.emit();
              },
              error: (err) => {
                this.spinnerVisibility = false;
                this.spinnerService.setSpinnerVisibility(false);
                this.showMessage();
                 this.captureService.processFinished.emit();

              }
            })
          }
        } else {
          if (SessionStorage.MrzData) {
            this.router.navigateByUrl('/idverificationok')
          }
        }

      }
    })
   
  }


  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })

      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: SessionStorage.IsMobile ? '100%' : '27%', 
        maxWidth: '95vw',
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  ngOnDestroy(): void {
    this.faceMatch$?.unsubscribe();
    this.idClassifier$?.unsubscribe();
  }



  showMessage() {
    if (SessionStorage.MrzData && this.hasImage) {
      this.message = this.translate.instant('photo.make_a_selfie')
    } else {
      if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
        this.message = this.translate.instant('photo.read_faceimage_side');
      }
      if (this.hasImage && !SessionStorage.MrzData) {
        this.message = this.translate.instant('photo.read_mrz_side');
      }

    }
  }

  sendVizaData() {
    let genderId: string;
    let documentTypeId: string;

    switch (SessionStorage.MrzData?.Sex) {
      case "M":
        genderId = "male";
        break;
      case "F":
        genderId = "female";
        break;
      default:
        genderId = "unknown";
    }
    if (SessionStorage.MrzData.DocumentType.includes('TD1') || SessionStorage.MrzData.DocumentType.includes('TD2')) {
      documentTypeId = 'I'
    }
    if (SessionStorage.MrzData.DocumentType.includes('TD3')) {
      documentTypeId = 'P'
    }

    let data: VizaData = {
      GuestStayUuId: SessionStorage.SelectedGuestData.GuestStayUuId,
      Hotel3pId: SessionStorage.ReservationInfo.Hotel3pId,
      Address: {
        City: '',
        Country: '',
        PostalCode: '',
        StreetAddress: '',

      },
      ScannedData: {
        Birthdate: DateHelper.FormatDate(SessionStorage.MrzData.DateOfBirth),
        BirthPlace: '',
        DateOfEntry: '',
        DocumentId: SessionStorage.MrzData.DocumentNumber,
        DocumentType: '',
        FirstName: HwUtils.toTitleCase(SessionStorage.MrzData.GivenNames),
        FirstNameAtBirth: '',
        Gender: genderId,
        LastName: HwUtils.toTitleCase(SessionStorage.MrzData.Surname),
        LastNameAtBirth: '',
        MothersFirstName: '',
        MothersLastName: '',
        Nationality: SessionStorage.MrzData.Nationality,
        Number: '',
        PlaceOfEntry: ''
      },
      ManualData: {
        Birthdate: '',
        BirthPlace: '',
        DateOfEntry: '',
        DocumentId: '',
        DocumentType: '',
        FirstName: '',
        FirstNameAtBirth: '',
        Gender: '',
        LastName: '',
        LastNameAtBirth: '',
        MothersFirstName: '',
        MothersLastName: '',
        Nationality: '',
        Number: '',
        PlaceOfEntry: ''
      }
    }

    this.vizaDataService.SendVizaData(data).subscribe(result => {
      // console.log(result);
      this.router.navigateByUrl('/idverificationok')
    })
  }

  showDialog(messageText: string, type: MessageType) {
    let messageData: GenericMessage = { messageText, messageType: type, showIcon: true }
    this.errorDialog.open(GenericMessageDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: messageData,
      width: SessionStorage.IsMobile ? '100%' : '27%', 
      maxWidth: '95vw',
      panelClass : 'modal-dialog'
    })
  }

  //region style functions

  hasMrz(): boolean {
    return SessionStorage.MrzData !== undefined ? true : false
  }

  showDetectionLimitError() {
    const dialogRef = this.dialog.open(DetectionLimitErrorDialogComponent,
      {
        disableClose: true,
        hasBackdrop: true,
        width: SessionStorage.IsMobile ? '100%' : '35%', 
      maxWidth: '95vw',
      })

    dialogRef.afterClosed().subscribe(forward => {
      SessionStorage.RetryCountImage = 0;
      SessionStorage.RetryCountMrz = 0;
      SessionStorage.RetryCountSelfie = 0;
      if (forward) {
        this.router.navigateByUrl('/vizadata')
      }
    })
  }

  imagePath() {
    const selfieImage = "../../../assets/images/selfie.png";
    const idFrontImage = "../../../assets/images/exi-mobil_front.png";
    const idBackImage = "../../../assets/images/exi-mobil_bck.png"

    if (LocalStorage.IsTabletMode) {
      if (LocalStorage.OperationMode == 'VIP') {
        if (SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_AND_SELFIE) {
          if (SessionStorage.MrzData && this.hasImage) {
            return selfieImage
          }
          if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
            return idFrontImage
          }
          if (this.hasImage && !SessionStorage.MrzData) {
            return idBackImage;
          }
        }
        if (SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_ONLY) {
          if (!SessionStorage.MrzData) {
            return idBackImage;
          }
        }
      } else {
        if (SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_AND_SELFIE) {
          if (SessionStorage.MrzData && this.hasImage) {
            return selfieImage
          }
          if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
            return idFrontImage
          }
          if (this.hasImage && !SessionStorage.MrzData) {
            return idBackImage;
          }
        }
        if (SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_ONLY) {
          if (!SessionStorage.MrzData) {
            return idBackImage;
          }
        }
      }
      // desktop 
    } else {
      if (SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_AND_SELFIE) {
        if (SessionStorage.MrzData && this.hasImage) {
          return selfieImage
        }
        if ((!this.hasImage && SessionStorage.MrzData) || (!this.hasImage && !SessionStorage.MrzData)) {
          return idFrontImage
        }
        if (this.hasImage && !SessionStorage.MrzData) {
          return idBackImage;
        }
      }
      if (SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_ONLY) {
        if (!SessionStorage.MrzData) {
          return idBackImage;
        }
      }
    }
  }


  //#endregion
}